<template>
  <div class="banner-relative-wrapper">
    <div :style="backgroundStyle" class="banner-wrapper">
      <div v-if="slice.primary.table_shadow" class="table-shadow"></div>
      <div
        class="background-container background-container-left"
        :style="{ 'background-image': `url(${leftImage}` }"
      ></div>
      <div
        class="background-container background-container-right"
        :style="{ 'background-image': `url(${rightImage}` }"
      ></div>
      <div class="banner-content">
        <div class="wrapper">
          <h1>
            <prismic-rich-text
              v-if="title"
              class="banner-title"
              :class="{ 'big-title': imageWithText }"
              :field="title"
              :style="{ color: textColor }"
            ></prismic-rich-text>
          </h1>
          <h2 class="subtitle text-center" :class="{ 'big-subtitle': imageWithText }">
            <prismic-rich-text
              v-if="subtitle1"
              :field="subtitle1"
              :style="{ color: textColor }"
            ></prismic-rich-text>
          </h2>

          <BannerSearch v-if="!hideSearchBar" :prismic-keyword="prismicKeyword" />
          <div class="banner-brands">
            <h2>
              <prismic-rich-text
                v-if="subtitle2"
                class="subtitle"
                :field="subtitle2"
                :style="{ color: textColor }"
              ></prismic-rich-text>
            </h2>
            <div v-if="suggestedSearches.length" class="banner-try-searching">
              <span :style="{ color: textColor }">{{ linksTitle }}</span>

              <component
                :is="search.blank ? 'a' : 'nuxt-link'"
                v-for="(search, idx) in suggestedSearches"
                :key="idx"
                :to="search.url"
                :href="search.url"
                class="suggestion"
                :target="!search.blank ? '_self' : '_blank'"
                :style="{ color: linksColor }"
              >
                <span>{{ search.text }}</span
                ><span class="comma">, </span>
              </component>
            </div>
            <div v-else-if="brands.length" class="banner-brands-row">
              <BrandsBlock
                :padding="7"
                :inline-desktop="true"
                :brands="brands"
                :text-color="textColor"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BannerSearch from '@/components/Home/BannerSearch';
import BrandsBlock from '@/components/Common/BrandsBlock';

export default {
  name: 'BannerContent',
  components: {
    BannerSearch,
    BrandsBlock
  },
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data: () => {
    return {
      title: '',
      subtitle1: '',
      subtitle2: '',
      textColor: '#000',
      brands: [],
      suggestedSearches: [],
      backgroundColor: '#000',
      backgroundImage: '',
      leftImage: '',
      rightImage: '',
      linksTitle: '',
      linksColor: '',
      hideSearchBar: true,
      prismicKeyword: ''
    };
  },
  computed: {
    imageWithText() {
      return this.brands[0]?.text && this.brands[0]?.src;
    },
    backgroundStyle() {
      const style = {};
      style.backgroundColor =
        this.backgroundColor && !this.backgroundImage ? this.backgroundColor : '';
      if (this.backgroundImage) {
        style.background = `url('${this.backgroundImage}') no-repeat center center;`;
      }
      return style;
    }
  },
  created() {
    const { primary, items } = this.slice;

    this.title = primary.title1[0]?.text ? primary.title1 : '';
    this.subtitle1 = primary.subtitle1[0]?.text ? primary.subtitle1 : '';
    this.subtitle2 = primary.subtitle2[0]?.text ? primary.subtitle2 : '';
    this.textColor = primary.text_color ? primary.text_color : '#000';
    this.linksColor = primary.links_color ? primary.links_color : '#000';
    this.linksTitle = primary.links_title[0]?.text ? primary.links_title[0].text : '';
    this.backgroundColor = primary.background_color ? primary.background_color : '#000';
    this.backgroundImage = primary.background_image?.url;
    this.leftImage = primary.left_image.url;
    this.rightImage = primary.right_image.url;
    this.hideSearchBar = primary.hide_searchbar;
    this.prismicKeyword = primary.search_keyword;
    if (items.length && items[0].image && items[0].image.url) {
      const itemsFiltered = items.filter((item) => item.image?.url);
      this.brands = itemsFiltered.map((item) => {
        return {
          src: item.image.url,
          alt: item.image.alt,
          text: item.link_text[0]?.text,
          url: item.link_url[0]?.text || '',
          blank: item.link_blank
        };
      });
    } else if (items.length && items[0].link_text.length && items[0].link_text[0].text) {
      this.suggestedSearches = items.map((item) => {
        return {
          text: item.link_text[0].text,
          url: item.link_url[0].text,
          blank: item.link_blank
        };
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.banner-relative-wrapper {
  position: relative;
  min-height: 544px;
  @include xl2 {
    min-height: 380px;
  }
  @include md {
    min-height: 300px;
  }
  @include sm {
    min-height: 260px;
  }
}
.banner-wrapper {
  position: absolute;
  width: 100vw;
  left: -23px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  overflow: unset;
  height: 100%;
  .table-shadow {
    height: 22%;
    width: 100%;
    position: absolute;
    bottom: 0px;
    box-shadow: 0px -10px 80px 0px rgba(255, 255, 255, 0.1);
    background: #00000010;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.15) 80%);
  }
  .background-container {
    position: absolute;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    min-width: 30%;
    width: 35%;
  }
  .background-container-left {
    background-position: left;
    left: 0px;
    @include xl3 {
      left: -100px;
    }
    @include xl2 {
      background-position: -40px;
      left: 0px;
    }
    @include xl {
      background-position: -100px;
    }
    @include lg {
      background-position: -140px;
      display: none;
    }
  }
  .background-container-right {
    right: 0px;
    background-position: right;

    @include xl3 {
      right: -100px;
    }
    @include xl2 {
      background-position: calc(100% + 40px);
      right: 0px;
    }
    @include xl {
      background-position: calc(100% + 80px);
    }
    @include lg {
      background-position: calc(100% + 120px);
      display: none;
    }
  }
  .banner-content {
    width: 33vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @include xl2 {
      width: 40vw;
    }
    @include xl {
      width: 45vw;
    }
    @include lg {
      width: 60vw;
    }
    @include md {
      width: 80vw;
    }
  }
  @include md {
    position: relative;
    padding: 15px 0;
  }
}
.wrapper {
  color: #474747;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.banner-brands {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 105%;
  .banner-brands-row {
    width: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
    img {
      position: relative;
      z-index: 100;
      min-width: 100%;
      height: auto;
      @include lg {
        margin-bottom: 12px;
        display: none;
      }
    }
  }
}
.banner-try-searching {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 12px;
  user-select: auto;
  margin-top: 20px;
  z-index: 100;
  @include md {
    margin-top: 0px;
    font-size: 10px;
  }
  .suggestion {
    margin-left: 2px;
  }
  .suggestion:last-child .comma {
    display: none;
  }
}
</style>

<style lang="scss">
.banner-content {
  .banner-title {
    justify-content: center;
    display: flex;
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      text-align: center;
      font-weight: 500;
      line-height: 1.5;
      font-size: 42px;
      @include xl2 {
        font-size: 28px;
      }
      @include lg {
        font-size: 24px;
        width: 70%;
      }
      @include md {
        width: 80%;
      }
      @include sm {
        width: 90%;
        font-size: 22px;
      }
    }
    &.big-title {
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        font-size: 48px;
        margin-bottom: 0;
        @include lg {
          font-size: 36px;
        }
        @include sm {
          font-size: 28px;
        }
      }
    }
  }
  .subtitle {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-size: 16px;
      font-weight: 400;
      margin-top: 15px;
      margin-bottom: 10px;
      @include lg {
        margin-bottom: 5px;
        margin-top: 15px;
        font-size: 14px;
      }
      @include sm {
        font-size: 12px;
      }
    }
    &.big-subtitle {
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        @include sm {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
